import { ticketCalendarNote } from "./ticketCalendarLink";

const brief = (value) => {
  const text = String(value || "").replace(/\s+/g, " ").trim();
  if (!text || /\bSubject:.*\bFrom:|--- Linked article|\[linked-article:|SCHOOL_NOTICE_IMAGE/i.test(text)) return "";
  const sentences = text.split(/(?<=[.!?])\s+(?=[A-Z])/).slice(0, 2).join(" ");
  return sentences.length > 360 ? sentences.slice(0, 357).trimEnd() + "…" : sentences;
};

// One description for both calendar destinations. Use saved concise event
// information, not raw email/attachment fields or the full update history.
export const calendarNotes = (event) => {
  const notes = [];
  for (const value of [event?.preparation_summary, event?.context, event?.notification_reason]) {
    const text = brief(value);
    if (text && !notes.some(note => note.toLowerCase() === text.toLowerCase())) notes.push(text);
  }
  if (event?.arrival_time) {
    const raw = String(event.arrival_time);
    const date = new Date(raw);
    const time = Number.isNaN(date.getTime()) ? raw : new Intl.DateTimeFormat("en-AU", {
      timeZone: "Australia/Sydney", hour: "numeric", minute: "2-digit", hour12: true,
    }).format(date);
    notes.push(`Arrival: ${time}`);
  }
  const tickets = ticketCalendarNote(event);
  if (tickets) notes.push(tickets);
  notes.push("Added from FrontRow Parents");
  return notes.join("\n\n");
};
